module.exports = __webpack_public_path__ + "img/lotus-on-cliff-min.c8717a33.png";